import {
  DataStatus,
  DynamicUi,
  DynamicUiRefProps,
  FormControl,
  Separator,
} from 'platform/components';
import {Heading, Hide, Show} from 'platform/foundation';

import {RefObject} from 'react';
import {UseFormReturn, useWatch} from 'react-hook-form';

// eslint-disable-next-line no-restricted-imports -- Intended
import {path} from 'ramda';

import {useGetSchemaQuery} from '@dms/api/core';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

import type {FormValues} from '../types/FormValues';

interface CustomFieldsNotificationSettingsProps {
  dynamicUiRef: RefObject<DynamicUiRefProps | null>;
  onValidSubmit: (values: Record<string, unknown>) => void;
  formApi: UseFormReturn<FormValues>;
  control: FormControl<FormValues>;
  documentCode: string;
  defaultValues: Record<string, any> | Nullish; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
}
const SCHEMA_ID = 'customer_message';

export function AdditionalSettings(props: CustomFieldsNotificationSettingsProps) {
  const isAutomatizationEnabled = useWatch({
    control: props.control,
    name: 'enabled',
  });

  const {
    data: schema,
    isLoading: isLoadingSchema,
    isError: isSchemaError,
    error,
  } = useGetSchemaQuery({id: `${SCHEMA_ID}-${props.documentCode}`});

  const isNotFoundError = path(['status'], error) === 404;

  return (
    <Hide when={isNotFoundError || isLoadingSchema}>
      <Separator spacing={0} />

      <Heading size={4}>{i18n.t('page.settings.notifications.anotherSettings')}</Heading>

      <DataStatus minHeight={20} isError={isSchemaError}>
        <Show when={schema?.root}>
          {(root) => (
            <DynamicUi
              ref={props.dynamicUiRef}
              onSubmit={props.onValidSubmit}
              schema={root}
              isReadOnly={!isAutomatizationEnabled}
              defaultValues={props.defaultValues ?? {}}
              onChange={(values) =>
                props.formApi.setValue('additionalSettings', values, {shouldDirty: true})
              }
            />
          )}
        </Show>
      </DataStatus>
    </Hide>
  );
}
